import { lazy } from "react";

export const UpdateRehabilitatorAsync = lazy(
  () => import("./UpdateRehabilitator")
);
